import React from 'react';
import { getCachedItem } from '../../../util/cache';
import { getPermittedMenuConfig } from '../../../util/getPermittedMenuConfig';
import { API } from '../../api';
import { Spinner } from '../../core';
import { useUserContext } from '../../user';
import { useAuthContext } from '../AuthContext';
import { Authenticated } from './Authenticated';
import { useEntityContext } from '../../../util/entity-provider/context';

export const IFrameAuthenticated = ({ entityRef, menuConfig }) => {
  const [busy, setBusy] = React.useState(true);
  const { isUserAuthorizedForEntity, setAuthorizedEntity } = useAuthContext();
  const userContext = useUserContext();
  const entityContext = useEntityContext();

  const token = getCachedItem('x-connex-id');

  React.useEffect(() => {
    API.setLoginToken(token);
  }, [token]);

  React.useEffect(() => {
    setAuthorizedEntity(entityRef);
    setBusy(false);
  }, [entityRef, setAuthorizedEntity]);

  const permittedMenuConfig = React.useMemo(() => {
    return getPermittedMenuConfig({ menuConfig: (menuConfig || {}).sidebarOptions, userContext, entityContext });
  }, [menuConfig, userContext, entityContext]);

  if (busy) return <Spinner spin={true} />;

  return isUserAuthorizedForEntity(entityRef) ? <Authenticated menuConfig={permittedMenuConfig} /> : null;
};
